var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgicalHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5227 14.9551H18.6099V18.2783H15.2869V22.191H18.6099V25.514H22.5227V22.191H25.8458V18.2783H22.5227V14.9551Z",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94141 8.67773H16.7758",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94141 13.3203H13.6803",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94141 17.9639H9.81084",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6045 22.6074H4.3936C3.98311 22.6074 3.58942 22.4444 3.29916 22.1541C3.0089 21.8638 2.84583 21.4701 2.84583 21.0596V4.03411C2.84583 3.62361 3.0089 3.22992 3.29916 2.93967C3.58942 2.6494 3.98311 2.48633 4.3936 2.48633H15.3611C15.7713 2.48642 16.1648 2.64934 16.4549 2.93931L19.4184 5.90279C19.7083 6.19293 19.8713 6.58634 19.8714 6.99655V12.303",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgicalHistory);
export default __webpack_public_path__ + "static/media/surgical_history.3187bbcca8ee13a02646c91d61af4869.svg";
export { ForwardRef as ReactComponent };